import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    HostListener
  } from '@angular/core'
  import { ModalStateService } from 'src/app/core/services/modal-state.service'
  import { FormGroup, Validators, FormControl } from '@angular/forms'
  import { OptionsStore } from '../options-utils/options-store'
import { ModalPopupsService } from '../modal-popups.service'
import { environment } from '../../../../../environments/environment'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

import {
  mobileHyphensComplete,
} from 'src/app/core/helpers/app-link'

  @Component({
    selector: 'web-prequal-options-qr-code',
    templateUrl: './web-prequal-options-qr-code.component.html',
    styleUrls: ['./web-prequal-options-qr-code.component.scss'],
    standalone: false
})
  export class WebPreQualOptionsQRCodeComponent implements OnInit {
    @Output() letsGetPhoneNumberSubmit: EventEmitter<any> = new EventEmitter()
    @Input() FULL_DEV: any = false
    @Input() isWebAppGetPhoneNumber = false
    @Input() breakpoints: any = {
      extraSmall: false,
      small: false,
      medium: false,
      large: true,
      extraLarge: true,
    }
    AMOUNT_REGEX = /^\$?[1-9][0-9\,]+$/
    showMask: boolean;
    showDollar: boolean;
    showErrMsg: boolean = false
    phoneNumberQRCodeImage: string = ""

    getPhoneNumberForm = new FormGroup({
      mobile: new FormControl('', [Validators.required,  Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]),
    });



    contentHeigt = 0
    @HostListener('window:resize', ['$event'])
      onResize(event) {
        this.contentHeigt = (window.innerHeight - 122);
      }
  
    
  public store: OptionsStore
   constructor(
      public modalStateService: ModalStateService,
      public modalPopupsService: ModalPopupsService,
      public sharedDataService: SharedDataService
    ) {
      this.contentHeigt = (window.innerHeight - 122);
    }
  
    prefillHit: any = false
    isWelcomeBack= false
    languageSelected: any
    welcomeUser =''
    dlToken=''

    ngOnInit(): void {
        if(environment.production){
          this.phoneNumberQRCodeImage = "QRCodePROD.png"
        } else {
          this.phoneNumberQRCodeImage = "QRCodeUAT.png"
        }
      }
  
    public async onGetPhoneNumberSubmit(): Promise<void> {
      if(this.getPhoneNumberForm.invalid) {
        this.showErrMsg = true
        setTimeout(() => {
          this.showErrMsg = false
        }, 2000);
      }
     this.getPhoneNumberForm.markAllAsTouched()
     if(this.getPhoneNumberForm.valid) {
      const mobileNumber = this.getPhoneNumberForm.controls.mobile.value?.replace(/-/g, "")

      const getPhoneNumberInputData = { mobile: mobileNumber };
      this.letsGetPhoneNumberSubmit.emit(getPhoneNumberInputData)
     }
    }


    numberOnly(event): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }

    getQRCodeImage(){
      return `images/${this.phoneNumberQRCodeImage }`
    }
  
    onMobileInput(e) {
      mobileHyphensComplete(e, e.target)
    }

  }
